import React from "react";
export const findQuestionData = (questions, questionId) => {
  const questionData = questions.find((question) => question.id === questionId);
  if (!questionData) {
    throw new Error(`Could not find question with ID ${questionId}`);
  }
  return questionData;
};

export const calculateAnswersNumber = (userAnswers) =>
  userAnswers.filter((answer) => typeof answer.level === "number").length;

export const findAnswerLevelToQuestion = (questionId, userAnswers) =>
  userAnswers.find((answer) => answer.questionId === questionId)?.level;

export const stringToHTML = (string) => {
  return <div dangerouslySetInnerHTML={{ __html: string }} />;
};
